import * as React from 'react';
export var ApplicationLauncherContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onFavorite: function onFavorite(itemId, isFavorite) {}
});